// extracted by mini-css-extract-plugin
export default {"overlayGradient":"CommonOverlayGradient_overlayGradient__G-9mt"};